var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3637 40.9091C32.6605 40.9091 41.8183 31.7513 41.8183 20.4545C41.8183 9.15781 32.6605 0 21.3637 0C10.067 0 0.90918 9.15781 0.90918 20.4545C0.90918 31.7513 10.067 40.9091 21.3637 40.9091Z",
    fill: "#75D7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9312 13.0444C22.9312 12.1788 22.2295 11.4771 21.3638 11.4771C20.4982 11.4771 19.7964 12.1788 19.7964 13.0444V19.0006H13.8399C12.9742 19.0006 12.2725 19.7024 12.2725 20.568C12.2725 21.4337 12.9742 22.1354 13.8399 22.1354H19.7964V28.0915C19.7964 28.9571 20.4982 29.6589 21.3638 29.6589C22.2295 29.6589 22.9312 28.9571 22.9312 28.0915V22.1354H28.8869C29.7525 22.1354 30.4543 21.4337 30.4543 20.568C30.4543 19.7024 29.7525 19.0006 28.8869 19.0006H22.9312V13.0444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWater);
export default __webpack_public_path__ + "static/media/plus_water.fee4423882f0a8b05efd152d0271237c.svg";
export { ForwardRef as ReactComponent };